module.exports = __webpack_public_path__ + "img/icon_solucoesTecnologia6.896378f3.jpg";